import React, { useState, useEffect } from "react";
import Layout, { Container } from "../components/layout";
import { FiPhoneCall } from "react-icons/fi";
import { GoCheckCircle } from "react-icons/go";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

function MyPlan() {
  const [activePlan, setActivePlan] = useState(null);

  // Simulate fetching user plan data from an API
  useEffect(() => {
    // Replace this with an API call
    const fetchPlanDetails = async () => {
      const planData = {
        name: "Basic Plan",
        price: 125,
        features: [
          "Super Admin",
          "Three Levels: Super Admin > Admin > User",
          "Templates, Basic Analytics",
          "WhatsApp & Email Integration",
          "Support Center",
          "Max. Catalogues: 50/user/month",
        ],
      };
      setActivePlan(planData);
    };

    fetchPlanDetails();
  }, []);

  const handleUpgrade = () => {
    console.log("Redirect to upgrade page");
  };

  return (
    <Layout>
      <Container>
        <div className="h-full w-full bg-gray-50 flex flex-col items-center p-6 overflow-scroll">
          <motion.h1
            className="text-2xl md:text-3xl lg:text-4xl text-center font-bold my-6 text-gray-800 tracking-wide"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            My Plan
          </motion.h1>

          <div className="flex flex-col lg:flex-row gap-6 w-full max-w-7xl">
            {/* Active Plan Card */}
            {activePlan && (
              <motion.div
                className="w-full lg:w-2/3 bg-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition duration-300"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
              >
                <h2 className="text-lg font-bold text-blue-600 mb-4">
                  Active Plan: {activePlan.name}
                </h2>
                <p className="text-gray-600 font-semibold text-3xl mb-4">
                ₹{activePlan.price}
                  <span className="text-slate-400 text-base font-medium">
                    /Month
                  </span>
                </p>
                <ul className="space-y-4 mb-6">
                  {activePlan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center">
                      <GoCheckCircle className="text-blue-600 mr-2 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={handleUpgrade}
                  className="w-full px-4 py-3 rounded-lg text-white bg-blue-500 hover:bg-blue-600 shadow-md transition"
                >
                  Upgrade Plan
                </button>
              </motion.div>
            )}

            {/* Upgrade Plan Card */}
            <motion.div
              className="w-full lg:w-1/3 bg-gradient-to-br from-blue-500 to-blue-700 text-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition duration-300"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h2 className="text-xl font-bold mb-4">Upgrade to Standard</h2>
              <p className="text-sm mb-6">
              Basic + Additional Features.
              </p>
              <ul className="space-y-4 mb-6">
                {[
                  "AI-Based Chatbot for Insights",
                  "AI-Based Catalog Curation",
                  "Max. Catalogues: 150/user/month",
                  "Work + Personal workspace",
                ].map((feature, idx) => (
                  <li key={idx} className="flex items-center">
                    <GoCheckCircle className="text-white mr-2 flex-shrink-0" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              <p className="text-white font-semibold text-3xl mb-4">
                ₹200
                  <span className="text-slate-400 text-base font-medium">
                    /Month
                  </span>
                </p>
              <button
                onClick={handleUpgrade}
                className="w-full px-4 py-3 bg-white text-blue-700 font-semibold rounded-lg shadow hover:bg-gray-100 transition"
              >
                Upgrade Now
              </button>
            </motion.div>
          </div>

          {/* Contact Information */}
          <motion.div
            className="w-full mt-8 bg-gradient-to-br from-purple-600 to-purple-800 text-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition duration-300 max-w-7xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="flex items-center mb-6">
              <div className="p-4 rounded-full bg-white text-purple-600 text-2xl">
                <FiPhoneCall />
              </div>
              <h2 className="text-xl font-bold ml-4">Contact Us</h2>
            </div>
            <p className="text-sm mb-6">
              Have questions? Let us help your team and organization achieve
              their goals with our solutions.
            </p>
            <Link to="https://fixall.ai/contact" target="_blank" className="bg-white w-full py-3 text-purple-800 font-semibold rounded-lg shadow hover:bg-gray-100 transition duration-300 mb-4 block justify-center text-center">
              Get in Touch
            </Link>
            <div>
              <p className="text-sm font-medium">Email: support@fixall.ai</p>
              <p className="text-sm font-medium">Phone: +91 963 4139 574</p>
            </div>
            <p className="text-xs mt-4">* Available for enterprise inquiries</p>
          </motion.div>
        </div>
      </Container>
    </Layout>
  );
}

export default MyPlan;
